import { Option } from 'components/Select/types';

export const NATIONALITY_OPTIONS: Option[] = [
  { label: 'White (e.g. Polish, German, English, Russian, etc.)', value: 'White' },
  {
    label: 'Hispanic Latino or Spanish origin (e.g. Mexican, Puerto Rican, Colombian, Brazilian, etc.)',
    value: 'Hispanic',
  },
  { label: 'Black or African American (e.g. African American, Haitian)', value: 'Black' },
  { label: 'Native American or Alaskan Native', value: 'Native American' },
  { label: 'Asian (e.g. Chinese, Japanese, Vietnamese)', value: 'Asian' },
  { label: 'Middle Eastern or North African (e.g. Syrian, Iranian, Lebanese, etc.)', value: 'Middle Eastern' },
  { label: 'African (e.g. Nigerian, South African, Ethiopian, Egyptian, etc.)', value: 'African' },
  { label: 'Some other race, ethnicity, or origin', value: 'Other' },
  { label: 'Prefer not to answer', value: 'N/A' },
];
